<template>
  <footer class="flex flex-wrap items-center h-20 px-6 text-xs">
    <div class="flex items-center justify-between w-full sm:block sm:w-auto">
      <a href="https://ricoma.com/US/terms-of-service" target="_blank" class="sm:mr-4">
        {{ $t('footer.terms') }}
      </a>
      <a href="https://ricoma.com/US/privacy-policy" target="_blank" class="sm:mr-4">
        {{ $t('footer.policy') }}
      </a>
    </div>
    <div class="w-full text-center sm:w-auto sm:ml-auto" style="color: #777777">
      &copy; {{ currentYear }} Ricoma International Corporation
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
